import { FC, useEffect } from 'react';
import {
    RouteComponentProps,
} from 'react-router-dom';
import { useDispatch } from 'react-redux';

import {
    showConfirm3DAction,
} from '@app/react/action';
import { hideEcHeaderNavi } from '@app/react/common/Function';

type PreviewProps = { props: RouteComponentProps & { isDesktop: boolean; isMobile: boolean } };

export const Preview: FC<PreviewProps> = (props) => {
    const { isDesktop, isMobile } = props;

    const dispatch = useDispatch();

    useEffect(() => {
        hideEcHeaderNavi(isDesktop, isMobile, dispatch);
    }, [isDesktop, isMobile, dispatch]);

    useEffect(() => {
        dispatch(showConfirm3DAction({ visible: true }));

        return () => {
            dispatch(showConfirm3DAction({ visible: false }));
        };
    }, [dispatch]);

    return null;
};
